import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { JUPYTER_PATHS } from './paths';

/** JupyterHub: три «планеты» Jupyter вокруг ноутбука. */
export const JupyterIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {JUPYTER_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
